<template>
  <div class="autocomplete-container">
    <input
      class="form-input"
      placeholder="Skriv for at søge"
      type="search"
      ref="dawa"
    />
    <!-- Suggestions will appear here -->
  </div>
</template>

<script>
/* eslint-disable */
import adressevaelger from "../../public/adressevaelger.cjs.js";
export default {
  mounted() {
    adressevaelger(this.$refs.dawa, {
token: "adressevaelger123",
select: (selected) => {
  console.log(selected)
        this.$emit("input", selected.adresse.adressebetegnelse)
}
    // console.log(adressevaelger)
    // dawaAutocomplete(this.$refs.dawa, {
    //     select: (selected) => {
    //     this.$emit("input", selected.tekst)
    //   },
    })
  },
};
</script>

<style>
.autocomplete-container {
  /* relative position for at de absolut positionerede forslag f�r korrekt placering.*/
  position: relative;
  width: 100%;
  max-width: 30em;
}

.autocomplete-container input {
  /* B�de input og forslag f�r samme bredde som omkringliggende DIV */
  width: 100%;
  box-sizing: border-box;
}

.dawa-autocomplete-suggestions {
  margin: 0.3em 0 0 0;
  padding: 0;
  text-align: left;
  border-radius: 0.3125em;
  /* background: #fcfcfc; */
  @apply bg-gray-50 shadow-xl border border-gray-200;
  /* box-shadow: 0 0.0625em 0.15625em rgba(0, 0, 0, 0.15); */
  position: absolute;
  left: 0;
  right: 0;
  z-index: 9999;
  overflow-y: auto;
  box-sizing: border-box;
}

.dawa-autocomplete-suggestions .dawa-autocomplete-suggestion {
  margin: 0;
  list-style: none;
  cursor: pointer;
  padding: 0.4em 0.6em;
  color: #333;
  /* border: 0.0625em solid #ddd; */
  @apply border-gray-200 border-b;
  /* border-bottom-width: 0; */
}

.dawa-autocomplete-suggestions .dawa-autocomplete-suggestion:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.dawa-autocomplete-suggestions .dawa-autocomplete-suggestion:last-child {
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
  border-bottom-width: 0.0625em;
}

.dawa-autocomplete-suggestions .dawa-autocomplete-suggestion.dawa-selected,
.dawa-autocomplete-suggestions .dawa-autocomplete-suggestion:hover {
  /* background: #f0f0f0; */
  @apply bg-gray-200 ring-2 ring-inset ring-aak-blue rounded-md;
}
</style>

